// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"36b306978ba6333e281d","397":"abf8679f35737463332d"}[chunkId] + ".css";
};